/*
 * spurtcommerce
 * version 4.5
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2021 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Api } from '../providers/api/api';

@Injectable()
export class CommentService extends Api {
    private base: string;


    public getComments(params): Observable<any> {
        this.base = this.getBaseUrl();
        return this.http.get(this.base + '/vendor-comment/list', { params: params });
    }

    public createComment(params): Observable<any> {
        this.base = this.getBaseUrl();
        return this.http.post(this.base + '/vendor-comment/create', params);
    }

    public updateComment(params): Observable<any> {
        this.base = this.getBaseUrl();
        return this.http.post(this.base + '/vendor-comment/update/' + params.id, params);
    }

    public updateHighLightedComments(params): Observable<any> {
        this.base = this.getBaseUrl();
        return this.http.post(this.base + '/vendor-comment/update-isHightlight/' + params.id, params);
    }
    

    public deleteComment(params): Observable<any> {
        this.base = this.getBaseUrl();
        return this.http.post(this.base + '/vendor-comment/delete', params);
    }

}
